import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEye, FiEdit } from "react-icons/fi";
// import { FiUpload, FiEdit } from 'react-icons/fi';
// import { FaUser, FaPaperPlane } from "react-icons/fa";
import "./UpcomingHourlyBookingTable.css";
import HourlyFloatBookingModal from "./HourlyFloatBookingModal/HourlyFloatBookingModal";
import EditBookingModal from "../../EditBookingModal/EditBookingModal";
import { editBookingAPI } from "../../../../utils/APIs/bookingsApis";
import { toast } from "react-toastify";
import ViewDetailsModal from "../../../../components/ViewDetailsModal/ViewDetailsModal";
import { buildHourlyBookingDetailRows } from "../../../../utils/viewDetailsBuilders";
import {
  getUserCancelledBookingTitle,
  isUserCancelledBooking,
} from "../../../../utils/bookingCancelUtils";

const UpcomingHourlyBookingTable = ({ data = [], page = 1, limit = 10, refetchData }) => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsBooking, setDetailsBooking] = useState(null);


  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
  };

  const handleFloatBooking = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const handleGalleryViewClick = (booking) => {
    setSelectedBooking(booking);
    const id = booking?.bookingId || booking?._id;
    navigate(`/bookings/hourly-view-gallery/${id}`);
  };

  const handleUpdateBooking = async (updatedData) => {
    try {

      const response = await editBookingAPI(selectedBooking.bookingId || selectedBooking._id, updatedData);
      if (response?.data?.success && response?.status === 200) {
        toast.success(response?.data?.message || "Booking Updated successfully!");
        if (refetchData) refetchData();
      } else {
        toast.error(response?.data?.message || "Failed to Update Booking!");
      }
      setShowEditModal(false);
    } catch (error) {
      console.error("Failed to update booking:", error);
      toast.error("An error occurred while updating.");
    } finally {
    }
  };

  const calculateSubTotal = (services = []) =>
    services.reduce((sum, s) => sum + (s.price || 0), 0);

  const calculateBookingTotal = (packages = []) =>
    packages.reduce((acc, pkg) => {
      const pkgTotal = calculateSubTotal(pkg.services);
      return acc + pkgTotal;
    }, 0);

  const formatStatus = (value) => {
    if (!value) return "Pending";
    return value
      .toString()
      .replace(/_/g, " ")
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };


  const displayData = data;

  const getBookingStatusText = (booking) => {
    return booking?.status || "Pending";
  };

  return (
    <div className="hourly-table-wrapper">
      <table className="hourly-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Booking ID</th>
            <th>Client Name</th>
            <th>Date</th>
            <th>Event Type</th>
            <th>Hours</th>
            <th>Package Type</th>
            <th>Package Details</th>
            <th>Total Amount</th>
            <th>Event Address</th>
            <th>Assigned Photographers</th>
            <th>Gallery View</th>
            <th>Gallery Upload Status</th>
            <th>Payment Status</th>
            <th>Booking Status</th>
            <th>Details</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {displayData.map((booking, bookingIndex) => {
            const bookingTotal = booking.finalAmount || booking.totalAmount || calculateBookingTotal(booking.hourlyPackages);
            const rowSpanCount = booking.hourlyPackages.length || 1;

            return booking.hourlyPackages.map((pkg, pkgIndex) => {
              const isFirst = pkgIndex === 0;

              return (
                <tr
                  key={`${booking.bookingId}-${pkgIndex}`}
                  className={isFirst ? "booking-highlight" : "booking-sub-row"}
                >
                  {isFirst && (
                    <td rowSpan={rowSpanCount} className="td-sr">
                      {(page - 1) * limit + bookingIndex + 1}
                    </td>
                  )}

                  {isFirst && <td rowSpan={rowSpanCount}>{booking.bookingId}</td>}
                  {isFirst && <td rowSpan={rowSpanCount}>{booking.clientName}</td>}

                  {isFirst && (
                    <td rowSpan={rowSpanCount} style={{ whiteSpace: "nowrap" }}>
                      {pkg.eventDate 
                        ? new Date(pkg.eventDate).toLocaleDateString("en-GB") 
                        : "-"}
                    </td>
                  )}

                  {isFirst && (
                    <td rowSpan={rowSpanCount}>
                      {booking.eventType || booking.shootType || "-"}
                    </td>
                  )}

                  <td>{pkg.hours}</td>

                  {isFirst && (
                    <td rowSpan={rowSpanCount}>
                      <span
                        className={`category-badge ${
                          pkg.category === "Premium"
                            ? "category-premium"
                            : "category-standard"
                        }`}
                      >
                        {pkg.category || "Standard"}
                      </span>
                    </td>
                  )}

                  <td>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px" }}>
                      <div>
                        {pkg.services.map((s, i) => (
                          <div key={i}>
                            {s.qty} {s.name} ₹{Math.round(s.price || 0).toLocaleString()}
                          </div>
                        ))}
                      </div>
                      <div style={{ fontWeight: "bold", whiteSpace: "nowrap", textAlign: "right" }}>
                        ₹{Math.round(pkg.subTotal || pkg.services.reduce((sum, s) => sum + (s.price || 0), 0)).toLocaleString()}
                      </div>
                    </div>
                  </td>



                  {isFirst && (
                    <>
                      <td rowSpan={rowSpanCount}>
                        <strong>₹ {Math.round(bookingTotal).toLocaleString()}</strong>
                      </td>
                      <td rowSpan={rowSpanCount}>{booking.eventAddress || "-"}</td>
                    </>
                  )}
                  <td>
                    {(() => {
                      const roles = [
                        { icon: "📸", assigned: pkg.assignedPhotographerNames || [], invited: pkg.invitedPhotographerNames || [] },
                        { icon: "🎥", assigned: pkg.assignedVideographerNames || [], invited: pkg.invitedVideographerNames || [] },
                        { icon: "✂️", assigned: pkg.assignedEditorNames || [], invited: pkg.invitedEditorNames || [] },
                        { icon: "💡", assigned: pkg.assignedLightingNames || [], invited: pkg.invitedLightingNames || [] }
                      ];
                      
                      const segments = roles
                        .filter(r => r.assigned.length > 0 || r.invited.length > 0)
                        .map(r => {
                            const combined = [];
                            if (r.assigned.length > 0) combined.push(r.assigned.join(", "));
                            if (r.invited.length > 0) combined.push(r.invited.map(n => `${n} (Pending)`).join(", "));
                            return `${r.icon} ${combined.join(", ")}`;
                        });

                      return segments.length > 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                          {segments.map((text, i) => <div key={i} style={{ fontSize: "12px" }}>{text}</div>)}
                        </div>
                      ) : "-";
                    })()}
                  </td>

                  {isFirst && (
                    <>
                      <td rowSpan={rowSpanCount}>
                        <button
                          className={`upload-btn d-flex align-items-center gap-2 ${!booking.hourlyPackages.some(pkg => (pkg.assignedPhotographerNames?.length > 0 || pkg.assignedVideographerNames?.length > 0 || pkg.assignedEditorNames?.length > 0 || pkg.assignedLightingNames?.length > 0)) ? "disabled" : ""}`}
                          onClick={() => handleGalleryViewClick(booking)}
                          disabled={!booking.hourlyPackages.some(pkg => (pkg.assignedPhotographerNames?.length > 0 || pkg.assignedVideographerNames?.length > 0 || pkg.assignedEditorNames?.length > 0 || pkg.assignedLightingNames?.length > 0))}
                          title={!booking.hourlyPackages.some(pkg => (pkg.assignedPhotographerNames?.length > 0 || pkg.assignedVideographerNames?.length > 0 || pkg.assignedEditorNames?.length > 0 || pkg.assignedLightingNames?.length > 0)) ? "Assign photographer first" : "View Gallery"}
                        >
                          <FiEye size={16} /> View
                        </button>
                      </td>
                      <td rowSpan={rowSpanCount}>
                        <span className={`status ${(booking.galleryStatus || "pending").replace(/\s+/g, '')}`}>
                          {booking.galleryStatus || "pending"}
                        </span>
                      </td>
                      <td rowSpan={rowSpanCount} style={{ textTransform: 'capitalize' }}>
                        <span className={`status ${(booking.paymentStatus || "pending").replace(/\s+/g, '')}`}>
                          {formatStatus(booking.paymentStatus)}
                        </span>
                      </td>
                      <td rowSpan={rowSpanCount} style={{ textTransform: 'capitalize' }}>
                        <span className={`status ${String(getBookingStatusText(booking)).toLowerCase().replace(/\s+/g, '')}`}>
                          {getBookingStatusText(booking)}
                        </span>
                      </td>
                      <td rowSpan={rowSpanCount}>
                        <button
                          type="button"
                          className="view-details-btn"
                          onClick={() => {
                            setDetailsBooking(booking);
                            setShowDetailsModal(true);
                          }}
                        >
                          View Details
                        </button>
                      </td>
                      <td rowSpan={rowSpanCount}>
                        <div className="d-flex flex-row gap-2 align-items-center justify-content-center">
                          <button
                            type="button"
                            className={`upload-btn ${isUserCancelledBooking(booking) ? "disabled" : ""}`}
                            onClick={() => {
                              if (isUserCancelledBooking(booking)) return;
                              handleFloatBooking(booking);
                            }}
                            disabled={isUserCancelledBooking(booking)}
                            title={getUserCancelledBookingTitle(booking)}
                          >
                            {(booking?.assignedPhotographer && booking?.displayStatus !== "Portal Cancel") ? "View Assigned Photographer" : "Float Booking"}
                          </button>
                          <button
                            type="button"
                            className={`upload-btn d-flex align-items-center gap-2 justify-content-center ${isUserCancelledBooking(booking) ? "disabled" : ""}`}
                            onClick={() => {
                              if (isUserCancelledBooking(booking)) return;
                              setSelectedBooking(booking);
                              setShowEditModal(true);
                            }}
                            disabled={isUserCancelledBooking(booking)}
                            title={getUserCancelledBookingTitle(booking, "Edit Booking")}
                          >
                            <FiEdit size={16} /> Edit
                          </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              );
            });
          })}
        </tbody>
      </table>

      {isModalOpen && (
        <HourlyFloatBookingModal
          booking={data.find(b => (b.bookingId || b._id) === (selectedBooking?.bookingId || selectedBooking?._id)) || selectedBooking}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          refetchData={refetchData}
        />
      )}

      {showEditModal && (
        <EditBookingModal
          booking={selectedBooking}
          isOpen={showEditModal}
          onClose={() => setShowEditModal(false)}
          onSave={handleUpdateBooking}
          refetchData={refetchData}
        />
      )}

      <ViewDetailsModal
        isOpen={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="Hourly Booking Details"
        rows={buildHourlyBookingDetailRows(detailsBooking)}
      />
    </div>
  );
};

export default UpcomingHourlyBookingTable;
